import styled, { keyframes } from 'styled-components';

type ContainerProps = {
  $size: number;
};

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const Container = styled.div<ContainerProps>`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  border: 2px solid rgba(0, 0, 0, 0.1);
  border-left-color: currentColor;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

export const ButtonWrapper = styled.div`
  width: auto;
`;
